const DateTime = {
  curTime: new Date().toLocaleDateString('en-GB'),
};

export default DateTime;
